import { useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, useWorkflow } from "bcms-react";
import Classes, { Payee } from "model";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import { PrimaryButton } from 'components/ui';
import React from 'react';
import MobileWirePayeesTable from "./components/MobileWirePayeesTable";
import WirePayeesTable from "./components/WirePayeesTable";
import "./mobile.css";
import "./styles.css";

/**
 * @function WirePayeesPage
 * @return {React.Component}
 * @exported true
 * @description The page that shows the wire payees
 */

export default function WirePayeesPage(props){
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  const { nextStep, state: workflow } = useWorkflow() ?? {};

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onChange: prop => value => {
        BCMSStateManagerCRUD.init(state)
              .update([ "data", prop ], value)
              .submit(setState);
      },

      addPayee: () => {
        const workflowState = BCMSStateManagerCRUD.init(workflow)
        .submit();
        nextStep(workflowState);
      },

      editPayee: id => () => {
        nextStep({ data: { selectedPayeeID: id } })
      }
  });

  return(
    <PageContainer className="wire-payees-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = () => ({
  payees: Payee.initAll()
});

export const getDefaultUI = () => ({
  // no ui changes for now
});

function PageContent(props) {
  const { data, addPayee } = useStateManager();

  return(
    <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Wire Payees" />
          <div className="show-on-desktop">
            <WirePayeesTable payees={ data.payees } />
          </div>
          <div className="show-on-mobile">
            <MobileWirePayeesTable payees={ data.payees } />
          </div>
          <PrimaryButton text="Add Payee" dataPoint="Wire_Payees_Add_Payee_Button" onClick={ addPayee } />
        </CenterContentContainer>
      </PageContentView>
  );
}